<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="m-4 mx-1 mt-4">
      <h2 class="font-weight-bold">{{ $t("category") }}</h2>
      <v-btn color="warning" dark :to="'/dashboard/categories/add'">
        {{ $t("add_category") }}
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          :label="$t('filter_by_category_name')"
          outlined
          dense
          v-model="filter"
          @input="fetchCategories"
        />
      </v-col>
    </v-row>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="categories"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 50],
          'items-per-page-text': $t('rows_per_page'),
        }"
        class="elevation-1"
        @update:page="fetchCategories"
        @update:items-per-page="fetchCategories"
      >
        <template
          v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }"
        >
          {{
            $t("pagination", {
              start: pageStart,
              end: pageStop,
              total: itemsLength,
            })
          }}
        </template>

        <template v-slot:item.id="{ item }">
          <a
            class="blue--text text--darken-2"
            @click.prevent="viewCategory(item)"
          >
            {{ item.id }}
          </a>
        </template>

        <template v-slot:item.addedBy="{ item }">
          {{ item.addedby.name }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="'/dashboard/categories/' + item.id + '/subcategories/add'"
              >
                <v-list-item-title>{{
                  $t("add_subcategory")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :to="'/dashboard/categories/' + item.id + '/subcategories'"
              >
                <v-list-item-title>{{
                  $t("view_subcategories")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="'/dashboard/categories/update/' + item.id">
                <v-list-item-title>{{
                  $t("update_category")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteCategory(item)">
                <v-list-item-title>{{ $t("delete") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <delete-modal v-model="deleteDialog" @confirm="confirmDelete" />
  </v-container>
</template>

<script>
import api from "../services/axios";
import DeleteModal from "../components/DeleteModal.vue";

export default {
  components: {
    DeleteModal,
  },
  data() {
    return {
      deleteDialog: false,
      selectedItem: null,
      filter: "",
      loading: false,
      totalItems: 0,
      categories: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      headersBase: [
        { text: "id", value: "id" },
        { text: "category", value: "name" },
        { text: "added_date", value: "created_at" },
        { text: "added_by", value: "addedBy" },
        { text: "subcategories", value: "total_subcategory" },
        { text: "action", value: "actions", sortable: false, align: "right" },
      ],
    };
  },
  watch: {
    "pagination.page": "fetchCategories",
    "pagination.itemsPerPage": "fetchCategories",
  },
  mounted() {
    this.fetchCategories();
  },
  computed: {
    headers() {
      return this.headersBase.map((header) => ({
        ...header,
        text: this.$t(header.text),
      }));
    },
  },
  methods: {
    async fetchCategories() {
      this.loading = true;
      try {
        const { page, itemsPerPage } = this.pagination;
        const res = await api.get("/category", {
          params: {
            page,
            perPage: itemsPerPage,
            filter: this.filter,
          },
        });

        this.categories = res.data.data.data; // or res.data.categories
        this.totalItems = res.data.data.total_records; // or res.data.meta.total
      } catch (error) {
        console.error("Failed to load categories:", error);
      } finally {
        this.loading = false;
      }
    },

    deleteCategory(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      try {
        const id = this.selectedItem.id;
        const res = await api.delete(`/category/delete/${id}`);
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          this.fetchCategories();
        }
      } catch (error) {
        this.$root.$emit("show-snackbar", {
          message: "Failed to delete category",
          color: "error",
        });
        console.error("Delete failed:", error);
      }
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>
